import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  baseURL: 'https://api.trafficstats.ru/api/v1/',
  // baseURL: 'http://localhost:8000/api/v1/',
})

axiosIns.interceptors.request.use(config => {
  if (config.params) {
    let params = { ...config.params }
    // eslint-disable-next-line
    for (const param in params) {
      if (params[param] && (typeof params[param] === 'string' || params[param] instanceof String)) {
        const parts = params[param].split('-')
        if (parts && parts.length > 2) {
          // eslint-disable-next-line no-param-reassign
          params[param] = `${parts[2]}.${parts[1]}.${parts[0]}`
        }
      }
    }

    if (params.filter) {
      // eslint-disable-next-line
      params.filter = JSON.stringify(Object.fromEntries(Object.entries(JSON.parse(params.filter)).filter(([_, v]) => v != null)))
    }

    params = new URLSearchParams(JSON.parse(JSON.stringify(params))).toString()
    if (config.url.indexOf('?') > -1) {
      // eslint-disable-next-line no-param-reassign
      config.url += `&${params}`
    } else {
      // eslint-disable-next-line no-param-reassign
      config.url += `?${params}`
    }
  }

  // eslint-disable-next-line no-param-reassign
  delete config.params

  return config
})

Vue.prototype.$http = axiosIns

export default axiosIns
